
import type { LanguageCode } from './languages';

const english = {
  badge: 'UK & US Plumbing Standard Tool',
  title: 'Copper Pipe Sizing & Flow Capacity Calculator',
  description:
    'Optimized for BS EN 1057 (Table X half-hard tube) and ASTM B88. Enforces strict erosion-corrosion velocity limits per CIBSE Guide G and CIPHE guidelines.',
  invalidFlow: 'Flow rate must be a positive number greater than 0.',
  invalidLength: 'Length must be a positive number greater than 0.',
  serviceType: 'Service Type & Velocity Limit',
  domesticCold: 'Domestic Cold Water',
  domesticHot: 'Domestic Hot Water',
  heatingPrimary: 'Central Heating Primaries',
  chilledWater: 'Chilled Water Secondary',
  quiet: 'Quiet',
  requiredFlow: 'Required Flow Rate',
  lengthRun: 'Length of Run',
  evaluationTitle: 'Standard UK Copper Sizes Evaluation (BS EN 1057 Table X)',
  nominalSize: 'Nominal Size',
  internalDia: 'Internal Dia',
  flowVelocity: 'Flow Velocity',
  pressureLoss: 'Pressure Loss / 10m',
  compliance: 'Compliance Verdict',
  recommended: 'Recommended',
  tooFast: 'Too Fast',
  oversized: 'Oversized',
};

const hindi = {
  badge: 'UK और US प्लंबिंग मानक टूल',
  title: 'कॉपर पाइप साइजिंग और फ्लो क्षमता कैलकुलेटर',
  description:
    'BS EN 1057 (Table X half-hard tube) और ASTM B88 के लिए अनुकूलित। CIBSE Guide G और CIPHE दिशानिर्देशों के अनुसार erosion-corrosion वेग सीमाओं को लागू करता है।',
  invalidFlow: 'प्रवाह दर 0 से अधिक धनात्मक संख्या होनी चाहिए।',
  invalidLength: 'पाइप की लंबाई 0 से अधिक धनात्मक संख्या होनी चाहिए।',
  serviceType: 'उपयोग का प्रकार और वेग सीमा',
  domesticCold: 'घरेलू ठंडे पानी की सप्लाई',
  domesticHot: 'घरेलू गर्म पानी की सप्लाई',
  heatingPrimary: 'सेंट्रल हीटिंग प्राइमरी पाइप',
  chilledWater: 'चिल्ड वॉटर सेकेंडरी पाइप',
  quiet: 'कम शोर',
  requiredFlow: 'आवश्यक प्रवाह दर',
  lengthRun: 'पाइप की लंबाई',
  evaluationTitle: 'UK कॉपर पाइप के मानक आकारों का मूल्यांकन (BS EN 1057 Table X)',
  nominalSize: 'नॉमिनल आकार',
  internalDia: 'आंतरिक व्यास',
  flowVelocity: 'प्रवाह वेग',
  pressureLoss: 'दाब हानि / 10m',
  compliance: 'अनुपालन स्थिति',
  recommended: 'अनुशंसित',
  tooFast: 'वेग बहुत अधिक',
  oversized: 'जरूरत से बड़ा',
};

export const copperCalculatorTranslations: Partial<
  Record<LanguageCode, typeof english>
> = {
  en: english,
  hi: hindi,
};

export function getCopperCalculatorText(language: LanguageCode) {
  return copperCalculatorTranslations[language] ?? english;
}
